// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__319z2","inner":"Form_inner__2-Z_u","range":"Form_range__2snx2","name":"Form_name__1-rL3","actions":"Form_actions__2OcMR"};